import React, { useEffect, useState, useRef } from 'react'
import Api from '../../../_helpers/Api'
import Pagination from '../../Pagination'
import { useHistory, useLocation } from 'react-router-dom'

import PartsPages from '../../partials/PartsPages'
import Skeleton from 'react-loading-skeleton'
import NoDataFound from '../../partials/NoDataFound'
import Dropdown from '../../partials/Dropdown'
import { fromInfo, trans } from '../../../_providers/Translation'
import Help from '../../partials/Help'
import AddOrEditAppliance from './partials/AddOrEditAppliance'
import AddOrEdit from './partials/AddOrEdit'
import Table from './partials/TableOfficeStock'
import Filter from './partials/Filter'
import Transfer from './partials/Transfer'
import History from './partials/History'
import Question from '@/components/modals/messages/Question'
import CorrectQuantity from './partials/CorrectQuantity'

let timeout

function Appliances(props) {

    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const modalAddOrEditRef = useRef(null)
    const modalCorrectRef = useRef(null)
    const modalTransferRef = useRef(null)
    const modalHistoryRef = useRef(null)
    const modalQuestionRef = useRef(null)

    const [parts, setParts] = useState({
        loading: true,
        data: [],
        total: 0,
        pages: 0,
        page: 1,
        filter: {
            stock: 'appliances',
            name: '',
            category_id: '',
            supplier_id: '',
            storage_id: '',
            box: '',
        },
        setFilter: false,
        update: false,
    })

    useEffect(() => {
        setParts(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                from: searchParams.get('from') || '',
                to: searchParams.get('to') || '',
                category_id: searchParams.get('category_id') || '',
                name: searchParams.get('name') || '',
                supplier_id: searchParams.get('supplier_id') || '',
                storage_id: searchParams.get('storage_id') || '',
                box: searchParams.get('box') || '',
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    useEffect(() => {

        if (parts.setFilter) {
            let url = '?page=' + parts.page

            Object.entries(parts.filter).map(filter => {
                if (filter[1]) {
                    url += '&' + filter[0] + '=' + filter[1]
                }
            })

            history.push(url)
        }

    }, [parts.setFilter])

    useEffect(() => {
        if (parts.update) {
            loadParts()
        }
    }, [parts.update])

    const loadParts = () => {
        setParts(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'storage/stock-appliances?page=' + parts.page

        Object.entries(parts.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {
                setParts(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data.items,
                    total: res.data.total,
                    pages: res.data.pages,
                    filter: {
                        ...prev.filter,
                        from: res.data.start,
                        to: res.data.end
                    }
                }))
            })
            .catch(() => {
                setParts(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    // Search
    const handleSearch = (key, val, delay = 300) => {
        clearTimeout(timeout)

        setParts(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
        }))

        timeout = setTimeout(() => {
            setParts(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, delay)
    }

    const handleCategory = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            setParts(prev => ({
                ...prev,
                filter: {
                    ...prev.filter,
                    category_id: val,
                },
                page: 1,
                setFilter: new Date().getTime()
            }))
        }

    }

    const handlePage = page => {
        setParts(prev => ({ ...prev, page: page.selected + 1, setFilter: new Date().getTime() }))
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleAdd = () => {
        modalAddOrEditRef.current.add()
    }

    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id)
    }

    const handleCorrect = id => {
        modalCorrectRef.current.show(id)
    }

    const handleCreate = () => {
        handleRefresh()
    }

    const handleUpdate = () => {

    }

    const handleAddInStorage = (id) => {
        // For OfficeStock, id is p.part.id, so find by p.part.id
        const product = parts.data.find(p => p.part && p.part.id === id)
        // Pass the full part object if needed, or the whole row
        if (product && modalAddOrEditRef.current && modalAddOrEditRef.current.openAddInStorageModal) {
            // You may want to pass product.part or product depending on modal needs
            modalAddOrEditRef.current.openAddInStorageModal(product.part ? product.part : product)
        }
    }

    const handleReload = () => {
        setParts(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const handleHistory = id => {
        modalHistoryRef.current.show(id)

        // history.replace('?subject_id=' + id + '&subject_type=' + 'App\\Storage');
    }

    const handleAcceptTransfer = id => {
        Api.post('storage/accept-transfer', {
            id: id
        }).then(res => {
            if (res.data) {

                let data = parts.data.map(i => {
                    if (i.id == id) {
                        i = res.data
                    }
                    return i
                })

                setParts(prev => ({
                    ...prev,
                    data: data
                }))
            }
        })
    }

    const handleTransfer = id => {
        modalTransferRef.current.show(id)
    }

    // delete
    const handleDelete = id => {

        let modal = modalQuestionRef.current

        modal.open(id)
        modal.onSuccess(() => {
            handleDestroy(id)
        })

    }

    const handleDestroy = id => {
        Api.post('storage/remove-part', {
            id: id
        }).then(res => {
            if (res.data.success) {
                handleRefresh()
            }
        })
    }

    const handleRefresh = () => {
        setParts(prev => ({
            ...prev,
            page: 1,
            update: new Date().getTime()
        }))
    }

    return (
        <>
            <AddOrEdit
                ref={modalAddOrEditRef}
                handleCreate={handleCreate}
                handleUpdate={handleRefresh}
                type={2}
            />

            <Transfer
                ref={modalTransferRef}
                handleRefresh={handleRefresh}
            />

            <History
                ref={modalHistoryRef}
            />

            <Question
                ref={modalQuestionRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />

            <CorrectQuantity
                ref={modalCorrectRef}
                handleRefresh={handleRefresh}
            />


            <div className="wrapper">
                <div className="top-part">
                    <div className="left">
                        <h1 className="page-heading">
                            {trans('headings.appliances')}
                            {/* <Help>{fromInfo('parts.mostUsed')}</Help> */}
                        </h1>
                        <p className="page-subheading">
                            {trans('subheadings.appliances')}
                        </p>
                    </div>
                    <div className="right">
                        <button className="button button-add" onClick={handleAdd}>
                            {trans('buttons.add')}
                        </button>
                    </div>
                </div>

                <div className='pannel'>
                    <Filter
                        filter={parts.filter}
                        handleSearch={handleSearch}
                    />
                    <hr />
                    {parts.loading
                        ?
                        <Skeleton height={45} count={10} />
                        :
                        parts.data.length === 0
                            ?
                            <NoDataFound />
                            :
                            <>
                                <Table
                                    parts={parts.data}
                                    filter={parts.filter}
                                    handleEdit={handleEdit}
                                    handleDelete={handleDelete}
                                    handleTransfer={handleTransfer}
                                    handleAcceptTransfer={handleAcceptTransfer}
                                    handleHistory={handleHistory}
                                    handleReload={handleReload}
                                    handleAddInStorage={handleAddInStorage}
                                    handleCorrect={handleCorrect}
                                />
                                <Pagination
                                    pages={parts.pages}
                                    page={parts.page}
                                    handlePage={handlePage}
                                />
                            </>
                    }
                </div>
            </div>
        </>
    )
}

export default Appliances